import { gql } from '@apollo/client';

export const TOURNAMENTS_FOR_TEAM = gql`
  query TournamentsForTeam($teamId: UUID!) {
    tournamentsForTeam(teamId: $teamId) {
      tournamentId
      tournamentName
      startDate
      endDate
      localTimeZone
      parentOrganisation {
        organisationId
        organisationName
      }
      venues {
        venueName
      }
    }
  }
`;
